import BlockWrapper from "@yumgmbh/gatsby-theme-yum-components/src/components/technical/BlockWrapper"
import React from "react"
import Image from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Image"
import Link from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Link"

import koinnobg from "../../../../images/koinno-bg.jpg"
import koinnologo from "../../../../images/koinno-logo.svg"
import koinnologoen from "../../../../images/koinno-logo-en.svg"

import { useTranslation } from "react-i18next"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faLongArrowRight } from "@fortawesome/pro-solid-svg-icons"

const KoinnoBannerBlock = ({ block }) => {
  const { t, i18n } = useTranslation()

  return (
    <BlockWrapper
      block={{ component: "koinno_banner_block" }}
      blockWidth="container"
    >
      <div className="relative -mx-grid">
        <Image className="object-cover w-full h-80 md:h-72" image={koinnobg} />
        <div className="absolute inset-0 px-4 pb-8 md:px-8">
          <div className="relative w-full h-full">
            <div
              className="inline-block p-8 bg-white"
              style={{ boxShadow: "inset 0 2px 5px rgba(0,0,0,.5)" }}
            >
              {i18n.language === "de" ? (
                <Image className="w-40" image={koinnologo} />
              ) : (
                <Image className="w-40" image={koinnologoen} />
              )}
            </div>
            <div className="bottom-0 left-0 mb-4 md:absolute md:mb-0">
              <p
                className="inline-block w-64 prose text-white sm:w-80"
                style={{ textShadow: "0 0 0.25rem black" }}
              >
                {t("koinno-banner.text")}
              </p>
            </div>
            http://www.koinno-bmwk.de/en/
            <Link
              className="bottom-0 right-0 inline-block px-4 py-2 leading-normal bg-white w-52 group md:absolute text-primary hover:underline"
              link={
                i18n.language === "de"
                  ? "https://www.koinno-bmwi.de/"
                  : "http://www.koinno-bmwk.de/en/"
              }
            >
              <FontAwesomeIcon
                icon={faLongArrowRight}
                size="1x"
                className="mr-2 text-red-700 transition-all duration-300 group-hover:mr-0.5 group-hover:ml-1.5"
              />
              {t("koinno-banner.button")}
            </Link>
          </div>
        </div>
      </div>
    </BlockWrapper>
  )
}

export default KoinnoBannerBlock
